<template>
    <div class="app-container">
        <div class="filter-head">
            <div class="filter-item">
                <el-input v-model="listQuery.title" placeholder="商品名称" />
            </div>
            <div class="filter-item">
                <el-date-picker v-model="filteDateRange" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm" @change="onChangeDateRange">
                </el-date-picker>
            </div>
            <div class="filter-item">
                <el-button type="primary" icon="el-icon-search" :loading="tableLoading" @click="handleFilter">搜索</el-button>
                <el-button type="warning" icon="el-icon-upload2" :loading="tableLoading"
                    @click="exportExcel">导出Excel</el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData" v-loading="tableLoading" border fit highlight-current-row>
                <el-table-column type="index" label="排行" width="100" align="center" />
                <el-table-column prop="name" label="商家" min-width="100" align="center" />
                <el-table-column prop="order_recommend_count" label="测评人数" min-width="100" align="center" />
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>

<script>
// 商家被测评排行
import { merchantRanking } from "@/api/statistic"
import * as XLSX from "xlsx"

export default {
    data: () => ({
        tableData: [],
        tableLoading: false,
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            title: '',
            start_at: null,
            end_at: null
        },
        filteDateRange: null
    }),
    methods: {
        async getList() {
            this.tableLoading = true
            this.tableData = []
            const { data } = await merchantRanking(this.listQuery)
            this.tableData = data.data
            this.total = data.total
            this.tableLoading = false
        },
        onChangeDateRange(t) {
            if (t === null) {
                this.listQuery.start_at = null
                this.listQuery.end_at = null
                return
            }
            this.listQuery.start_at = t[0]
            this.listQuery.end_at = t[1]
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList()
        },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')

            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await merchantRanking({ ...this.listQuery, page: 1, limit: total })

                var wb = XLSX.utils.book_new();

                var excelData = [
                    ['排行', '商家', '测评人数'],
                    ...reqData.map((item, index) => [
                        index + 1,
                        item.name,
                        item.order_recommend_count
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "测评排行");
                XLSX.writeFile(wb, "数据统计-商家被测评排行.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.filter-head {
    display: flex;
    align-items: center;
    margin: 0 -5px;

    .filter-item {
        margin: 0 5px;
    }
}

.table {
    margin-top: 10px;
}
</style>